import React from 'react';
import { graphql } from 'gatsby';
import SinglePost from '../components/single-post';

const Post = (props) => (
  <SinglePost
    {...props.data.post}
    highlightedPosts={props.data.highlightedPosts.nodes}
    lang="nl"
  />
);

export default Post;

export const postQuery = graphql`
  query BlogPostByPath($path: String!, $category: Int) {
    post: wpPost(uri: { eq: $path }) {
      path: uri
      title
      date
      content
      excerpt
      author {
        node {
          name
        }
      }
      featuredImage {
        node {
          mediaDetails {
            height
            width
          }
          mediaItemUrl
          gatsbyImage(
            layout: CONSTRAINED
            placeholder: BLURRED
            width: 1200
            quality: 80
          )
        }
      }
    }
    highlightedPosts: allWpPost(
      filter: {
        status: { eq: "publish" },
        uri: { ne: $path },
        categories: {
          nodes: {
            elemMatch: {
              databaseId: {
                eq: $category
              }
            }
          }
        }
      }
      limit: 4
    ) {
      nodes {
        id
        title
        date
        path: uri
        featuredImage {
          node {
            filename
            altText
            gatsbyImage(
              layout: FIXED
              placeholder: BLURRED
              width: 280
              height: 190
              cropFocus: ENTROPY
            )
          }
        }
      }
    }
  }
`;
